import { HStack, Icon, VStack, Text } from '@cad-arc';
import { DexQueryView } from '@mark43/dex-api';
import { getArcHitColor, getIconForDexEntityType } from '../utils';

export function QuerySummary({
    query,
    hasHits,
}: {
    query: DexQueryView;
    hasHits: boolean;
}): React.ReactElement {
    return (
        <HStack
            spacing={2}
            padding="var(--arc-space-2) var(--arc-space-3) var(--arc-space-2) var(--arc-space-2)"
        >
            <Icon
                icon={getIconForDexEntityType(query.dexEntityType)}
                color={hasHits ? 'raw.red.500' : 'icon.default'}
            />
            <VStack alignItems="flex-start" spacing={0} w="100%">
                <Text
                    noOfLines={2}
                    variant="bodyMd"
                    style={{ color: getArcHitColor(hasHits) }}
                    fontWeight={hasHits ? 'bold' : undefined}
                >
                    {query.formattedQuery}
                </Text>
            </VStack>
            {hasHits && <Icon icon="ExclamationPoint" color="raw.red.500" />}
        </HStack>
    );
}
